<template>
  <div class="mb-4 p-3">
    <div class="row align-items-center">
      <div class="col-4 m-0">
          <div class="avatar-upload">
            <div class="avatar-edit">
            </div>
            <div class="avatar-preview">
              <img
                ref="imageViewPreview"
                class="avatar-lg rounded-lg"
                alt
              />
            </div>
          </div>
      </div>
      <div class="col-xl-8 col-lg-12">
        <label for="" class="form-label">{{$t('function.form.name.label')}}</label>
        <input 
          type="text" 
          readonly
          class="form-control-plaintext mb-2"
          v-model="model.name"
        >

        <label for="" class="form-label">{{ $t('function.form.remarks.label') }}</label>
        <p>{{ model.remarks || 'N/A' }}</p>
      </div>
    </div>
  </div>
  <!-- <div class="row">
    <div class="col-sm-12">
      <div class="row border-bottom mb-2">
        <div class="avatar-upload">
          <div class="avatar-preview">
            <img
              alt
              ref="imageViewPreview"
              class="avatar-md image_background"
            />
          </div>
        </div>
        <div class="row">

          <div class="col-12">

            <div class="form-group">

            </div>

          </div>

        </div>

        <div class="row">

          <div class="col-12">

          </div>

        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
export default {
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    brandID() {
      let parameters = this.parameters || {}
      return parameters.brandID
    }
  },
  data () {
    return {
      model: {}
    }
  },
  methods: {
    fetchData() {
      let param = {}
      param.id = this.brandID

      return this.$store.dispatch('brand/find', param)
      .then(res => {
        if (res && res.data) {
          this.model = res.data
          if(res.data.logo)
          this.$refs.imageViewPreview.src =res.data.logo
          else
          this.$refs.imageViewPreview.src = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973461_960_720.png';
        }
      })
    }
  },
  watch: {
    brandID: function () {
      this.fetchData()
    }
  },
  mounted() {
    if (this.brandID) {
      this.fetchData()
    }
  }
}
</script>